





























import useI18n from 'vue-i18n';
import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import formatCurrency from '~/helpers/formatCurrency';
import { Product } from '~/modules/catalog/product/types';
import { useMagentoConfiguration } from '~/composables';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'ProductTierPrice',
  components: {
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup(props) {
    const productTierPriceData = computed(() => props.product.price_tiers);
    const { selectedCurrency } = useMagentoConfiguration();

    const i18nLocale = new useI18n();
    const currentLocale = i18nLocale.locale;

    const currency = selectedCurrency.value;

    return {
      productTierPriceData,
      formatCurrency,
      currentLocale,
      currency,
    };
  },
});
